import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './upgrade-screen.page.html',
  styleUrls: ['./upgrade-screen.page.scss']
})
export class UpgradeScreenPage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  goUpdate(){

  }

}
